import React from 'react';

import TransCustom from '../transCustom/TransCustom';
import InquiryForm from './InquiryForm';
import InquiryFormProvider from './InquiryFormProvider';
import type { InquirySubmitAction } from './inquirySubmission';

type Props = {
  submitAction?: InquirySubmitAction;
};

export default function InquiryFormContainer({ submitAction }: Props) {
  return (
    // grid-cols-2 는 repeat(2, minmax(0,1fr)) 라 원본 `1fr 1fr`(=minmax(auto,1fr))과 다르다.
    <div className="grid gap-[40px] lg:mt-[clamp(54px,8.333vw,100px)] lg:grid-cols-[1fr_1fr] lg:justify-between lg:gap-[clamp(40px,3.125vw,60px)]">
      <div className="mt-[54px] flex flex-col gap-[8px] lg:mt-0 lg:gap-[clamp(8px,1.333vw,16px)]">
        <h3 className="text-[24px] font-bold leading-[140%] tracking-[-0.48px] text-apps-coreGray01 lg:text-[clamp(24px,3.429vw,48px)] lg:leading-[120%] lg:tracking-[-0.96px]">
          <TransCustom i18nKey="디플리에게 궁금한 점이 있으신가요?" />
        </h3>
        <h4 className="text-[16px] font-medium leading-[140%] tracking-[-0.32px] text-apps-brandGray200 lg:text-[clamp(16px,1.667vw,20px)] lg:leading-[160%] lg:tracking-[-0.4px]">
          <TransCustom i18nKey="디플리에게 궁금한 점이 있으시다면 문의를 남겨주세요. 빠르게 답변을 드리겠습니다." />
        </h4>
      </div>

      <div>
        <InquiryFormProvider>
          <InquiryForm submitAction={submitAction} />
        </InquiryFormProvider>
      </div>
    </div>
  );
}
